/* 🤖 this file was generated by svg-to-ts */
export const matIconSignalCellularNull: {
  name: 'signal-cellular-null';
  data: string;
} = {
  name: 'signal-cellular-null',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 6.83V20H6.83L20 6.83M22 2 2 22h20V2z"/></svg>`
};
